import React, { useState, useEffect } from 'react';
import { Container, Button, Modal, Form } from 'react-bootstrap';
import arrowLeft from "../assets/images/arrow-left.png";
import { Link } from 'react-router-dom';
import { addWalletAmount, getWalletTransactions } from '../services/walletApi';
import LoadingSpinner from './LoadingSpinner';
import { showToast } from '../config/Alert';
import config from '../config/config';

const Wallet = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [show, setShow] = useState(false);
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(true);
  const [balance, setBalance] = useState(0);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Fetch wallet balance and transactions
  const fetchWalletData = async () => {
    try {
      const response = await getWalletTransactions(user.id);
      setBalance(response.balance);
    } catch (error) {
      showToast("Failed to fetch wallet data:", 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWalletData();
  }, []);

  const handlePayment = async () => {
    if (!amount || isNaN(amount) || amount <= 0) {
      showToast("Please enter a valid amount.", 'error');
      return;
    }

    setLoading(true);

    try {
      // Razorpay options
      const options = {
        key: config.Razorpay_Key, // Replace with your Razorpay key
        amount: amount * 100, // Amount in paise
        currency: "INR",
        name: "The Pied Piper",
        description: "Add Money to Wallet",
        handler: async (response) => {
          // Handle successful payment
          const paymentData = {
            user_id: user.id, // Replace with dynamic user ID
            amount: parseFloat(amount),
            transaction_id: response.razorpay_payment_id,
          };

          try {
            const result = await addWalletAmount(paymentData);
            showToast("Money added successfully!", 'success');
            setAmount('');
            setShow(false);
            fetchWalletData(); // Refresh wallet balance after successful payment
          } catch (error) {
            showToast("Failed to add money to wallet.", 'error');
          }
        },
        prefill: {
          name: user.name,
          email: user.email,
        },
        theme: {
          color: "#F37254",
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (error) {
      showToast("Payment failed. Please try again.", 'error');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className='app-container mobile-bottom'>
      <Container className='mb-4'>
        <div className='breadcrum bg_light_yellow'>
          <h2 className='d-flex align-items-center mb-0 fs-20'>
            <Link to='/dashboard'><img src={arrowLeft} width={18} className='me-2' alt="link" /></Link>
            Wallet</h2>
        </div>
        <div className='walletSection mt-4'>
          <div className='smallShawdow'></div>
          <div className='walletBalance ps-4 pt-5'>
            <small className='fw-bold'>Wallet<br /> Balance</small>
            <h3>₹{balance}</h3>
          </div>
          <div className='trans_btn text-center'>
            <Link to='/paymentHistory' state={{ source: 'wallet' }} className='text-danger fs-10'>View Recent Transactions</Link>
          </div>
          <div className='border-2 my-4 border-bottom'></div>
          <div className='text-center'>
            <Button variant="warning" size='lg' type="submit" onClick={handleShow} className='px-5 fs-14 rounded-0'>
              Add Money
            </Button>
          </div>
        </div>
      </Container >

      <Modal size='sm' show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className='fs-16 py-0'>Add Amount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="amount">
            <Form.Control
              type="text"
              placeholder="Enter Amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="info" className='rounded-4 px-3' size='sm' onClick={handlePayment} disabled={loading}>
            {loading ? "Processing..." : "Add Amount"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div >
  );
};

export default Wallet;